export const WorkData = [
  {
    company: "SAINT",
    designation: "Chief Technology Officer",
    dateJoining: "May 2025",
    dateEnd: "Present",
    companyLogo: "",
    work: "Working on CI/CD pipelines, deployment automation, and cloud infrastructure that improves release efficiency, scalability, and system reliability. Assisting in infrastructure optimization, environment configuration, and deployment processes that supports faster and more stable software delivery. Collaborating with engineering and design teams to streamline build systems, reduce deployment friction, and improve overall operational performance.",
  },
  {
    company: "AlienUI Org.",
    designation: "Creator & Lead Maintainer",
    dateJoining: "Feb 2025",
    dateEnd: "Jan 2026",
    companyLogo: "",
    work: "Designed and shipped AlienUI-React/AlienUI (React/React Native UI library), gaining early global traction via Github Projects and Tublian with 100+ GitHub stars and 6+ open-source contributors in the first week. Built AlienX, a VSCode extension used by SME engineering teams, which garnered 100+ installations in one week, and released AlienIcons, a customizable SVG icon set based on Heroicons for production use.",
  },
];
